<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">
          Histórico de Importações
          <button class="btn-icon botao-setinha-voltar" (click)="goBackPage()">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
          </button>
        </h1>
        <p class="paragrafo mb-4">Relatório de importações realizadas</p>

        <div class="row">
          @if (historicoImportacao) {
            <div class="col-6 col-md-3">
              <div class="mb-4">
                <label class="label-menor" for="dataInicial">Data Inicial</label>
                <input class="form-control" dateMask [matDatepicker]="picker" placeholder="dd/mm/aaaa" [(ngModel)]="dataInicial"
                  [ngClass]="{ 'is-invalid': dataInicialError }" (dateChange)="onDataInicialPedido();checkLimite90Dias()" id="dataInicial">
                <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker-custom"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                @if (dataInicialVazia) {
                  <p class="legenda-erro mt-1 mb-0">Seleciona a data inicial</p>
                }
                <field-error [isError]="dataInicialError" [message]="dataInicialMessageError"></field-error>
              </div>
            </div>
          }
          @if (historicoImportacao) {
            <div class="col-6 col-md-3">
              <div class="mb-4">
                <label class="label-menor" for="dataFinal">Data Final</label>
                <input class="form-control" dateMask [matDatepicker]="picker1" placeholder="dd/mm/aaaa" [(ngModel)]="dataFinal"
                  [ngClass]="{ 'is-invalid': dataFinalError }" (dateChange)="onDataFinalPedido();checkLimite90Dias()" id="dataFinal">
                <mat-datepicker-toggle matSuffix [for]="picker1" class="datepicker-custom"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                @if (dataFinalVazia) {
                  <p class="legenda-erro mt-1 mb-0">Selecione a data final</p>
                }
                <field-error [isError]="dataFinalError" [message]="dataFinalMessageError"></field-error>
              </div>
            </div>
          }
          @if (historicoImportacao) {
            <div class="col-12 col-md-3">
              <div class="mb-3">
                <br>
                  <button class="botao mt-2" [disabled]="dataInicialError != false || dataFinalError != false || dataInicialLength != true || dataFinalLength != true" (click)="consultaHistoricoImportacoes()">FILTRAR</button>
                  <button class="botao-outline ms-2 mt-2" (click)="limparFiltro()">LIMPAR FILTRO</button>
                </div>
              </div>
            }
            @if (historicoImportacao) {
              <div class="col-0 col-md-3 disabled"></div>
            }

            <div class="col-12">
              <!-- TABELA -->
              @if (historicoImportacao) {
                <table class="table table-hover border-bottom mt-4" aria-describedby="tabela que lista historico de importacoes">
                  <thead>
                    <tr>
                      <th scope="col">DATA</th>
                      <th scope="col">HORÁRIO</th>
                      <th scope="col">TIPO ARQUIVO</th>
                      <th scope="col">STATUS</th>
                      <th scope="col">NOME</th>
                      <th scope="col">DOWNLOAD</th>
                      <th scope="col">ERRO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- LINHA 1 -->
                    @for (importacao of historicoImportacao.content; track importacao) {
                      <tr>
                        <td>{{importacao.dataImportacao.slice(0,10)}}</td>
                        <td>{{importacao.dataImportacao.slice(11,16)}}</td>
                        @if (importacao.descricaoStatus == 'FINALIZADO') {
                          <td>Importação concluída</td>
                        }
                        @if (importacao.descricaoStatus != 'FINALIZADO' && importacao.descricaoStatus != 'CANCELADO PELO USUÁRIO') {
                          <td>Importação concluída com problemas</td>
                        }
                        @if (importacao.descricaoStatus == 'CANCELADO PELO USUÁRIO') {
                          <td>Importação cancelada pelo usuário</td>
                        }
                        <td>{{importacao.descricaoFase | camelCase}}</td>
                        <td>{{importacao.descricaoTipoArquivoImportacao}}</td>
                        <td>
                          <button
                            (click)="downloadImportacao(importacao)"
                            id="btnDownloadPedido{{importacao.idImportacao}}"
                            class="btn-icon"
                            >
                            <i class="fa fa-download c-primary" aria-hidden="true"></i>
                          </button>
                        </td>
                        @if (importacao.contemInconsistencias == true) {
                          <td>
                            <button
                              (click)="downloadErrosImportacao(importacao.idImportacao)"
                              id="btnDownloadErrosImportacao{{importacao.idImportacao}}"
                              class="btn-icon">
                              <i class="fa fa-download c-primary hand" aria-hidden="true"></i>
                            </button>
                          </td>
                        }
                        @if (importacao.contemInconsistencias != true) {
                          <td></td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              }

              @if (historicoImportacao === null) {
                <div>
                  <div class="text-center">
                    <output class="spinner-border c-primary">
                      <span class="visually-hidden">Consultando histórico de importações ...</span>
                    </output>
                  </div>
                  <p class="legenda-spinner">Consultando histórico de importações ...</p>
                </div>
              }

              @if (historicoImportacao === false) {
                <div class="text-center">
                  <img src="/assets/img/erro.png" width="230px" alt="Erro">
                  <p class="legenda-erro">Ocorreu um erro na consulta do histórico de importações.</p>
                </div>
              }

              @if (historicoImportacao === undefined) {
                <div class="text-center">
                  <img src="/assets/img/vazio.png" width="230px" alt="nao possui importacoes">
                  <p class="legenda-vazio">Você ainda não possui importações.</p>
                </div>
              }
            </div>

            @if (historicoImportacao) {
              <div class="col-12">
                @if (historicoImportacao) {
                  <div class="footer-card">
                    <div class="container-select">
                      <app-select (change)="alteraQuantidadePorPagina()"
                        ngClass="select-outline"
                        [value]="tamanho"
                        (valueChanges)="tamanho = $event"
                                          name="tamanhoName" [options]="[
                                                  {name : 'Exibir 5 históricos' , value : '5000'} ,
                                                  {name : 'Exibir 10 históricos' , value : '10'} ,
                                                  {name : 'Exibir 15 históricos' , value : '15'}

                                                  ]" optionValue="value" optionText="name">
                      </app-select>
                    </div>
                    <div class="py-0 px-3">
                      @for (item of itensPaginacao; track item) {
                        <button
                          class="itens-pagina btn-icon"
                          [ngClass]="{ 'item-ativo': pagina == item.valor }"
                          (click)="alteraPagina(item.valor)"
                          >
                          {{item.pagina}}
                        </button>
                      }
                    </div>
                    @if (historicoImportacao.totalElements == 1) {
                      <p class="paragrafo text-end float-end">
                        <strong>{{historicoImportacao.totalElements}}</strong> Registro foi encontrado</p>
                      }
                      @if (historicoImportacao.totalElements != 1) {
                        <p class="paragrafo text-end float-end">
                          <strong>{{historicoImportacao.totalElements}}</strong> Registros foram encontrados</p>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-footer></app-footer>
